import React from "react";
import { Route, Redirect } from "react-router-dom";
import isAuthenticated from "./isAuthenticated";

export default function PublicRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={props => {
                return isAuthenticated() ?
                    <Redirect
                        to={{
                            pathname: "/orders",
                            state: { from: props.location }
                        }}
                    /> :
                    <Component {...props} />
            }
            }
        />
    );
}

